    'use strict';

module.exports = ['$translateProvider', function ($translateProvider) {
    $translateProvider.translations('it', require('../languages/it'));
    $translateProvider.translations('en', require('../languages/en'));

//    $translateProvider.preferredLanguage('it');
    $translateProvider.useSanitizeValueStrategy('escape');
}];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/configs/TranslateProvider.js
// module id = 350
// module chunks = 0